export default __webpack_public_path__ + "static/media/MSDLAF_Site_Logo.1aca1058.png";